import React from "react";
import LearnMore from "../../../../components/learnMore/learnMore";

const MembershipLearnMore = (props) => {
  return <LearnMore title="Membership" content={getContent(props)} html />;
};

const getContent = (props) => {
  const {
    clientName,
    riskMembersDaysFromLastVisit,
    riskMembersDaysPrevLastVisit,
    exampleDate,
    startDateWithVisit,
    endDateWithVisit,
    startDateWithoutVisit,
    endDateWithoutVisit
  } = props;
  return `
        <h3>Membership Sales</h3>
        This looks at the the month-to-date sales by membership sales package as identified in
        iKizmet’s sales package mapping page. The percentage change shows the month to date this
        month compared to the month to date last month which indicates if membership sales are
        trending up or down.
        <br />
        <br />
        <h3>Members</h3>
        This metric looks at today’s (or select month’s) active number of Members and compares to
        the previous month on the same day.
        <br />
        <br />
        <h3>New Members</h3>
        This metric displays the number of new members from the selected month. New members is
        specially filtered to only show ${clientName} that signed up for membership for the first
        time; meaning we’ve excluded returning members.
        <br />
        <br />
        <h3>Zero Visit Members</h3>
        This metric displays the number of <i>active</i> members that have zero visits during the
        selected month (excludes members on suspension). The number might look high at the beginning
        of the month but it should decline as the month moves forward.
        <br />
        <br />
        Use this value for understanding the total number of at risk members. By evaluating the
        trend using the percent change from previous month you can determine if your at risk members
        is increasing or decreasing over time.
        <br />
        <br />
        <h3>At Risk Members You Should Contact</h3>
        These <i>active</i> members have been identified because there is still time to save them
        from terminating their membership. The list contains the highest paying members that did not
        have a visit in the last ${riskMembersDaysFromLastVisit} days but had a visit in the{" "}
        ${riskMembersDaysPrevLastVisit} days previous.
        <br />
        <br />
        For example, if today is ${exampleDate}st, the list will show members who had at least one
        visit between ${startDateWithVisit} through ${endDateWithVisit} but didn’t have a visit from{" "}
        ${startDateWithoutVisit} to ${endDateWithoutVisit}.
        <br />
        <br />
        Frozen members will NOT be included in the At Risk Members count.
        <br />
        <br />
        The module will display the top three highest spending ${clientName} out of all members that
        match this criteria.
      </>
    `;
};

export default MembershipLearnMore;
